import Vue from 'vue';
import App from './App.vue';
import Router from 'vue-router';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import NProgress from 'nprogress';
import VueAgile from 'vue-agile';
import * as VueGoogleMaps from 'vue2-google-maps';
import axios from 'axios';
import VueAxios from 'vue-axios';
import 'swiper/dist/css/swiper.css';
import '../node_modules/nprogress/nprogress.css';
import VueCurrencyFilter from 'vue-currency-filter';
import BackToTop from 'vue-backtotop';
import { VueStars } from 'vue-stars';
import zoom from 'vue-image-zoom';
import imageZoom from 'vue-image-zoomer';
import 'vue-image-zoom/dist/vue-image-zoom.css';
import store from '@/store';
import data from '@/staticData.json';
import { getSections } from '@/service/sections.service';
import VueNumberInput from '@chenfengyuan/vue-number-input';
import VueMeta from 'vue-meta';
import { useAxiosCustomInterceptor } from '@/helpers/interceptor.helpers';
import { basicRoutes, accountRoutes, ecommerceRoutes, getDynamicRoutes } from '@/router';
import { useFilters } from '@/helpers/filters.helpers';

const isEcommercePage = data.general.isEcommercePage;
const isLoggingAvailable = data.general.isLoggingAvailable;

Vue.use(VueAxios, axios);
Vue.use(Router);
Vue.use(zoom);
Vue.use(VueGoogleMaps, { load: { key: '', libraries: 'places' } });
Vue.use(BackToTop);
Vue.use(VueNumberInput);
Vue.component('vue-stars', VueStars);
Vue.component('image-zoom', imageZoom);
Vue.use(VueAwesomeSwiper);
Vue.use(VueAgile);
Vue.config.productionTip = false;
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});
Vue.use(VueCurrencyFilter, {
  symbol: 'S/',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: true,
});
useFilters();
useAxiosCustomInterceptor();

const mountApp = (router) => {
  router.beforeResolve((to, from, next) => {
    if (to.name) {
      NProgress.start();
    }
    next();
  });

  router.afterEach(() => {
    NProgress.done();
  });

  let vm = new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
};

getSections()
  .then((response) => {
    const sections = response.data;
    const dynamicRoutes = getDynamicRoutes(sections);
    const router = new Router(basicRoutes);
    if (isLoggingAvailable) {
      router.addRoutes(accountRoutes);
    }
    if (isEcommercePage) {
      router.addRoutes(ecommerceRoutes);
    }
    router.addRoutes(dynamicRoutes);
    mountApp(router);
  })
  .catch((error) => {
    console.log('Network Error');
  });
